import { render } from "./ProjectInfoView.vue?vue&type=template&id=6f1332bb&ts=true"
import script from "./ProjectInfoView.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoView.vue?vue&type=script&lang=ts"

import "./ProjectInfoView.vue?vue&type=style&index=0&id=6f1332bb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__